import { useQuery } from '@tanstack/react-query';
import { roleApi } from '../api/roleApi';

/**
 * GET /api/eraf/roles/{id} — 역할 상세 조회
 * queryKey: ['role-management', 'detail', id]
 */
export function useRoleDetail(id: number | undefined) {
  return useQuery({
    queryKey: ['role-management', 'detail', id],
    queryFn: () => roleApi.get(id!),
    enabled: id !== undefined && id > 0,
    staleTime: 30_000,
  });
}
